import { Component, ViewEncapsulation } from '@angular/core';

/**
 * A Modal Component footer.
 * @export
 * @class ModalFooterComponent
 */
@Component({
  selector: 'pru-modal-footer',
  templateUrl: './modal-footer.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ModalFooterComponent {}
